import { connect } from "react-redux";
import SendDeposit from "../components/SendDeposit";
import { requestAddNewDepositFile, onDrop, removeButton, removeFileFromList, checkIfSent, setReadyToSend, setValueSelect, removeFileFromUploadsList } from "../actions";

function mapStateToProps(state) {
    return {
        files: state.files, //fichiers qui vont s'ajouter
        depositInformations: state.depositInformations,
        loadPercent: state.loadPercent,
        removeClickable: state.removeClickable,
        isSent: state.isSent,
        almostReady: state.almostReady,
        listFiles: state.listFiles, //fichiers visibles sur la boîte de dépôt
        fileToUpload: state.fileToUpload
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            addNewDepoFile: (newFile) => {
                dispatch(requestAddNewDepositFile(newFile));
            },
            onDrop: (files) => {
                dispatch(onDrop(files));
            },
            removeButton: (check) => {
                dispatch(removeButton(check));
            },
            removeFileFromList: (index) => {
                dispatch(removeFileFromList(index));
            },
            removeFileFromUploadsList: (fileIds) => {
                dispatch(removeFileFromUploadsList(fileIds));
            },
            checkIfSent: (check) => {
                dispatch(checkIfSent(check));
            },
            setReadyToSend: (check) => {
                dispatch(setReadyToSend(check));
            },
            setValueSelect: (value) => {
                dispatch(setValueSelect(value))
            }
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SendDeposit);
